// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ik-0";
export var fileCarousel = "_ik-2";
export var removeFileButton = "_ik-1";